import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CONSTANTS } from 'src/app/const';
import { DataService } from 'src/app/services/data.service';
import { ProductService } from 'src/app/services/product.service';
import {Meta, Title} from '@angular/platform-browser';
import {ProductDto} from "../../entities/product/ProductDto";
import {environment} from "../../../environments/environment";

@Component({
  selector: 'app-search-results',
  templateUrl: './search-results.component.html',
  styleUrls: [ './search-results.component.scss' ]
})
export class SearchResultsComponent implements OnInit, OnDestroy  {
  title: string = ' Find Your Lab Test | Grassroots Labs Search';
  defaultTitle: string = 'Grassroots Labs - Blood Tests are Expensive. We fix that.';
  metaDescription: string = 'Easily search for your required lab test from a comprehensive list at Grassroots Labs. Affordable, ' +
    'transparent, and physician-backed testing is just a click away. Start your search now.';

  searchMessage: string = '';
  tests: ProductDto[] = [];
  imageURL: string = environment.baseIconUrl;
  page: number = 1;
  testsCount: number;

  constructor(
    private productService: ProductService,
    private router: Router,
    private dataService: DataService,
    private metaService: Meta,
    private titleService: Title
  ) {}

  ngOnInit(): void {
   this.setPageMetadata();

    this.dataService.currentMessage.subscribe(message => {
      if (message !== this.searchMessage) {
        this.searchMessage = message;
        this.onWordChange();
      }
    });
  }

  testNavigate(test: ProductDto): void {
    this.router.navigateByUrl(`product/${test.slug}`);
  }

  onPageChange(currentPage: number): void  {
    const limit = 10;
    const offset = (currentPage - 1) * limit;
    this.productService.findProducts(this.searchMessage, limit, offset).subscribe(result => {
      this.tests = result.entities;
      this.testsCount = result.totalCount;
    });
    scroll(0, 0);
  }

  onWordChange(): void {
    this.productService.findProducts(this.searchMessage, 10, 0).subscribe(
      (result) => {
        this.tests = result.entities;
        this.testsCount = result.totalCount;
      }
    );
    scroll(0, 0);
    this.page = 1;
  }

  allTestsNavigate(): void {
    this.router.navigate(['/all']);
  }

  ngOnDestroy(): void {
    this.resetMetadata();
  }

  // Metadata functions
  private resetMetadata(): void {
    this.titleService.setTitle(this.defaultTitle);
    this.metaService.removeTag('name="description"');
  }

  private setPageMetadata(): void {
    this.titleService.setTitle(this.title);
    this.metaService.addTag({ name: 'description', content: this.metaDescription });
  }
}


